"use client";

import type { ComponentProps } from "react";
import { NumberInput } from "@leabankab/component-library";
import { FormField } from "@leabankab/component-library/react-hook-form";

export type NumberFieldProps = Omit<
	ComponentProps<typeof NumberInput>,
	"name" | "value" | "defaultValue" | "onValueChange" | "error"
> & { name: string };

/** The library `NumberInput`, bound to the surrounding react-hook-form form. */
export const NumberField = ({ name, ...props }: NumberFieldProps) => (
	<FormField
		name={name}
		render={({ field }) => (
			<NumberInput {...props} {...field} value={field.value ?? null} />
		)}
	/>
);
